export class Errors {
  constructor(public errors: Error[]) {}
}

class Error {
  constructor(public code: string, public message: string) {}
}
